import React, { useRef } from 'react';

const ContactOneForm = () => {
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();
    const formData = new FormData(form.current);
    const data = Object.fromEntries(formData.entries());

    try {
      const res = await fetch('https://d2l873mxalz3b9.cloudfront.net/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await res.json();
      if (result.success) {
        alert('Thank you! We’ve received your submission. You’ll hear from our team soon!');
        form.current.reset();
      } else {
        alert('Failed to send email.');
      }
    } catch (err) {
      console.error('Email send error:', err);
      alert('Error occurred while sending email.');
    }
  };

  return (
    <div className="contact-form-wrap">
      <form ref={form} onSubmit={sendEmail}>
        <div className="row merriweather-sans">
          <div className="col-md-6">
            <div className="form-grp">
              <input type="text" placeholder="Enter your Name" name="name" required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <input type="email" placeholder="Enter your email" name="email" required />
            </div>
          </div>
        </div>
        <div className="form-grp">
          <textarea className="merriweather-sans" name="message" placeholder="Enter your message" required></textarea>
        </div>
        <div className="submit-btn text-center">
          <button type="submit" className="btn">
            Send Message
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactOneForm;
